import $ from "jquery";
import Formatter from "@rmlibrary/formatting";

const formatter = new Formatter();
const language = getLanguage();
const storageKeyPrefix = "ca.dynamic.calculators.";

function getDateRangeFromDate(date, range) {
    let [month, year] = date.split("/");
    year = Number(year);
    let endDate = new Date(`${month}/01/${year}`);
    const startDateMonth = month - 1 < 1 ? 12 : month - 1;
    let startDate = new Date(`${startDateMonth}/01/${year - range}`);
    endDate = formatter
        .formatDate(endDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");
    startDate = formatter
        .formatDate(startDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");

    return `${startDate} - ${endDate}`;
}

function getNoDayDateFromDate(date) {
    let [month, year] = date.split("/");
    year = Number(year);
    let formattedDate = new Date(`${month}/01/${year}`);
    formattedDate = formatter.formatDate(formattedDate, "mmm yyyy").replace(/June/g, "Jun").replace(/July/g, "Jul");

    return formattedDate;
}

function getRGBFromHex(hex, toString = false) {
    const rgb = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));

    return toString ? `rgb(${rgb})` : rgb;
}

function getValue(object, path) {
    function getResult(separator) {
        return path
            .split(separator)
            .filter((part) => part)
            .reduce((result, part) => (result !== null && result !== undefined ? result[part] : result), object);
    }

    if (!path) {
        return null;
    }

    const result = getResult(/[,[\]]+?/) || getResult(/[,[\].]+?/);
    return result === undefined || result === object ? null : result;
}

function outputAttribute(name, inputs, callback) {
    $(".print-page-wrapper, rm-html-pdf")
        .find(`[${name}]`)
        .each((i, element) => {
            const path = $(element).attr(name);
            const value = getValue(inputs, path);
            callback(element, value);
        });
}

function buildTranscriptHTML(descriptions) {
    return () =>
        descriptions.map((description) => {
            const paragraph = document.createElement("p");
            paragraph.innerText = description;

            return paragraph;
        });
}

function filterObjectByKeys(object, keys, blacklisted = true) {
    return Object.keys(object).reduce((accumulator, k) => {
        let returnValue = accumulator;

        if ((blacklisted && !keys.includes(k)) || (!blacklisted && keys.includes(k))) {
            returnValue = {
                ...accumulator,
                [k]: object[k]
            };
        }

        return returnValue;
    }, {});
}

function formatLargeCurrency(amount) {
    let formattedAmount = null;

    if (amount >= 1000000000) {
        const normalizedAmount = amount / 1000000000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "b" : " G";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 1000000) {
        const normalizedAmount = amount / 1000000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "m" : " M";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 10000) {
        const normalizedAmount = amount / 1000;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, 0);
        const abbreviation = language === "en" ? "k" : " k";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 1000) {
        const normalizedAmount = amount / 1000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "k" : " k";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else {
        formattedAmount = formatter.formatCurrency(amount, 0);
    }

    return formattedAmount;
}

function generatePDF(inputs) {
    const currentDate = new Date();

    inputs = {
        ...inputs,
        currentDate
    };

    outputAttribute("data-alt", inputs, (element, value) => $(element).attr("alt", value));

    outputAttribute("data-colour", inputs, (element, value) => {
        if (value.indexOf("#") > -1) {
            value = getRGBFromHex(value, true);
        }

        $(element).css("background-color", value);
    });

    outputAttribute("data-if", inputs, (element, value) => {
        if (!value) {
            $(element).hide();
        }
    });

    outputAttribute("data-src", inputs, (element, value) => {
        if (value) {
            const base = $(element).attr("data-src-base") || "";
            if ($(element).css("visibility") === "hidden") {
                $(element).one("load", () => $(element).css("visibility", "visible"));
            }
            $(element).attr("src", `${base}${value}`);
        }
    });

    outputAttribute("data-output-currency", inputs, (element, value) => {
        try {
            let decimals = $(element).attr("data-output-decimals");
            if (decimals === "auto") {
                decimals = value % 1 !== 0 ? 2 : 0;
            } else {
                decimals = Number($(element).attr("data-output-decimals")) || 0;
            }

            $(element).text(formatter.formatCurrency(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-date", inputs, (element, value) => {
        try {
            const type = $(element).attr("data-output-type");

            if (type === "noDay") {
                $(element).text(getNoDayDateFromDate(value));
            } else if (type === "range") {
                let range = $(element).attr("data-output-range");
                range = getValue(inputs, range) || 1;

                $(element).text(getDateRangeFromDate(value, range));
            } else {
                const format = getLanguage() === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";

                $(element).text(formatter.formatDate(value, format));
            }
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-number", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;

            $(element).text(formatter.formatNumber(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-percentage", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;
            const inputType = $(element).attr("data-input-type") || "percent";

            if (inputType === "decimal") {
                value *= 100;
            }

            $(element).text(formatter.formatPercentage(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-text", inputs, (element, value) => {
        let textValue = value ? value.toString() : "";
        const lineBreakCharacter = $(element).attr("data-output-line-break-character") || "";
        if (textValue && lineBreakCharacter) {
            const characterIndex = textValue.indexOf(lineBreakCharacter);
            if (characterIndex > -1) {
                textValue = `${textValue.slice(0, characterIndex)}<br />${textValue.slice(characterIndex)}`;
            }
        }

        $(element).html(textValue);
        $(element).css("visibility", "visible");
    });
}

function getLanguage() {
    return document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
}

function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const textMetrics = context.measureText(text);

    return textMetrics.width;
}

function getValueFromInput(selector) {
    const { checked, type, value } = document.querySelector(selector);

    if (type === "checkbox" || type === "radio") {
        return checked;
    }

    return value;
}

function hidePopup(popup) {
    return () => $(popup).css("visibility", "hidden");
}

function retrieveFromStorage(page) {
    const storageKey = `${storageKeyPrefix}${page}`;

    return JSON.parse(sessionStorage.getItem(storageKey));
}

function roundToNiceNumber(number, factor = 1, mode = "ceiling") {
    const { length } = Math.round(number).toString();
    const multiplier = 10 ** (length - 2) * factor;

    let result = Math.ceil(number / multiplier);
    if (mode === "floor") {
        result = Math.floor(number / multiplier);
    }

    return result * multiplier;
}

function sanitiseDescriptions(descriptions) {
    return descriptions
        .reduce((descs, currentDescription) => {
            return !descs || descs.map((desc) => desc.text).indexOf(currentDescription.text) > -1
                ? descs
                : descs.concat(currentDescription);
        }, [])
        .sort(function (desc1, desc2) {
            if (desc1.startTime === desc2.startTime) {
                if (desc1.type === "caption" && desc2.type === "description") {
                    return 1;
                } else if (desc2.type === "caption" && desc1.type === "description") {
                    return -1;
                }
            }
            return desc1.startTime - desc2.startTime;
        })
        .map((currentDescription) => currentDescription.text);
}

function saveToStorage(page, value) {
    const storageKey = `${storageKeyPrefix}${page}`;

    sessionStorage.setItem(storageKey, JSON.stringify(value));
}

function showPopup(popup, updateContent, isBar, points) {
    return (dataName, x, y, xPos, yPos, xValOnGraph, yValOnGraph, isLine) => {
        if (!isLine) {
            if (updateContent) {
                updateContent({ dataName, popup, x, y });
            }

            let barWidthOffset = 0;
            let barTopOffset = 0;
            const xOffset = $(popup).outerWidth() / 2;
            const yOffset = $(popup).outerHeight() + 20;

            if (isBar) {
                const point = points.filter((point) => point.x === x && point.y === y)[0];

                barWidthOffset = Math.abs(point.coords.x2 - point.coords.x1) / 2;
                if (y < 0) {
                    barTopOffset = Math.abs(point.coords.y2 - point.coords.y1);
                } else {
                    barTopOffset = 15;
                }
            }

            $(popup).css({
                left: `${xValOnGraph - xOffset + barWidthOffset}px`,
                top: `${yValOnGraph - yOffset - barTopOffset}px`,
                visibility: "visible"
            });
        }
    };
}

export {
    buildTranscriptHTML,
    filterObjectByKeys,
    formatLargeCurrency,
    generatePDF,
    getLanguage,
    getTextWidth,
    getValueFromInput,
    hidePopup,
    retrieveFromStorage,
    roundToNiceNumber,
    sanitiseDescriptions,
    saveToStorage,
    showPopup
};
